import { render, staticRenderFns } from "./CreateRequest.vue?vue&type=template&id=0f8708f0&"
import script from "./CreateRequest.vue?vue&type=script&lang=js&"
export * from "./CreateRequest.vue?vue&type=script&lang=js&"
import style0 from "./CreateRequest.vue?vue&type=style&index=0&id=0f8708f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports